import { defineMessages } from '../../i18n/messages';

export const UseCasesMessages = defineMessages({
  TITLE: {
    id: 'homepage.use_cases.title',
    text: 'Use Cases',
    description: 'Section heading for the use cases section',
  },
  SUBTITLE: {
    id: 'homepage.use_cases.subtitle',
    text: 'See how Localingos preserves your placeholders across different scenarios',
    description: 'Subtitle below the use cases heading',
  },
  APP_LOCALIZATION_TITLE: {
    id: 'homepage.use_cases.app_localization_title',
    text: 'App / Website Localization',
    description: 'Title for the app localization use case card',
  },
  APP_LOCALIZATION_DESC: {
    id: 'homepage.use_cases.app_localization_desc',
    text: 'Ship globally without manual overhead',
    description: 'Short description for the app localization use case card',
  },
  APP_LOCALIZATION_CODE_TITLE: {
    id: 'homepage.use_cases.app_localization_code_title',
    text: 'React i18n Example',
    description: 'Code example title for the app localization use case',
  },
  TRANSACTIONAL_TITLE: {
    id: 'homepage.use_cases.transactional_title',
    text: 'Transactional Messages',
    description: 'Title for the transactional messages use case card',
  },
  TRANSACTIONAL_DESC: {
    id: 'homepage.use_cases.transactional_desc',
    text: 'Emails/SMS with dynamic variables',
    description: 'Short description for the transactional messages use case card',
  },
  TRANSACTIONAL_CODE_TITLE: {
    id: 'homepage.use_cases.transactional_code_title',
    text: 'Email Template Example',
    description: 'Code example title for the transactional messages use case',
  },
  DEVELOPER_TOOLING_TITLE: {
    id: 'homepage.use_cases.developer_tooling_title',
    text: 'Developer Tooling',
    description: 'Title for the developer tooling use case card',
  },
  DEVELOPER_TOOLING_DESC: {
    id: 'homepage.use_cases.developer_tooling_desc',
    text: 'Safe automation for i18n string sets',
    description: 'Short description for the developer tooling use case card',
  },
  DEVELOPER_TOOLING_CODE_TITLE: {
    id: 'homepage.use_cases.developer_tooling_code_title',
    text: 'API Response Example',
    description: 'Code example title for the developer tooling use case',
  },
  PLACEHOLDERS_PRESERVED: {
    id: 'homepage.use_cases.placeholders_preserved',
    text: 'Placeholders Preserved',
    description: 'Badge text shown on each use case card indicating placeholders are preserved',
  },
  CODE_LABEL_ORIGINAL: {
    id: 'homepage.use_cases.code_label_original',
    text: 'Original',
    description: 'Label above the original code snippet in the use case demo',
  },
  CODE_LABEL_TRANSLATED: {
    id: 'homepage.use_cases.code_label_translated',
    text: 'Translated',
    description: 'Label above the translated code snippet in the use case demo',
  },
});